import { fromJS } from 'immutable';
import { createSelector } from 'reselect';
import { GetWorkingHours } from '../../api/Support';

// ACTIONS TYPES
export const FETCH_WORKING_HOURS_SUCCESS = 'customer-portal/support/FETCH_WORKING_HOURS_SUCCESS';
export const FETCH_WORKING_HOURS_FAILURE = 'customer-portal/support/FETCH_WORKING_HOURS_FAILURE';
export const FETCHING_WORKING_HOURS = 'customer-portal/support/FETCHING_WORKING_HOURS';

// ACTION CREATORS
export const fetchWorkingHoursSuccess = workingHoursData => ({
  type: FETCH_WORKING_HOURS_SUCCESS,
  payload: { days: workingHoursData.days, holidays: workingHoursData.holidays },
});

export const fetchWorkingHoursFaiure = err => ({
  type: FETCH_WORKING_HOURS_FAILURE,
  payload: err,
});

export const fetchingWorkingHours = () => ({
  type: FETCHING_WORKING_HOURS,
});

// SELECTORS
const supportSelector = state => state.support;

export const getWorkingHours = createSelector([supportSelector], support => support.get('workingHours'));
export const getWorkingHoursLoading = createSelector([supportSelector], support => support.get('loading') || !support.get('loaded'));

// THUNKS
export const fetchWorkingHours = () => async dispatch => {
  dispatch(fetchingWorkingHours());
  try {
    const { data } = await GetWorkingHours();
    dispatch(fetchWorkingHoursSuccess(data));
  } catch (error) {
    dispatch(fetchWorkingHoursFaiure(error.message));
  }
};

// TODO: Change this to refresh if the data is stale too
export const shouldFetchWorkingHours = supportState => !supportState.get('loaded') && !supportState.get('loading');

export const fetchWorkingHoursIfNeeded = () => (dispatch, getState) => {
  if (!shouldFetchWorkingHours(getState().support)) {
    return null;
  }

  return dispatch(fetchWorkingHours());
};

// REDUCER
export const initialState = fromJS({
  loaded: false,
  loading: false,
  error: null,
  workingHours: null,
});

const findStep = ({ steps, from, to, sequence }) => {
  return steps.find(s => s.from === from && s.to === to && s.sequence === sequence);
};

// Makes first lattter uppercase
const ucfirst = string => {
  return string.charAt(0).toUpperCase() + string.toLowerCase().slice(1);
};

// TODO {holidays}
const prepareSchedule = ({ days }) => {
  let sequence = 0;
  const steps = [{ from: 0, to: 0, days: [], sequence }];

  for (let i = 0; i < days.length; i += 1) {
    const day = days[i];

    if (!day.isClosedAllDay) {
      const dayStr = day.day.toLowerCase();
      const from = day.openTime;
      const to = day.closeTime;

      const step = findStep({ steps, from, to, sequence });

      if (step) {
        step.days.push(dayStr);
      } else {
        sequence += 1;
        steps.push({ from, to, days: [dayStr], sequence });
      }
    } else {
      sequence += 1;
    }
  }

  return steps
    .filter(s => s.days.length > 0)
    .map(s => {
      // if there is more then 2 days - we add a dash between them, like Mon-Tue
      // else we use coma - Monday, Tuesday
      const daysStr = s.days.length > 2 ? `${ucfirst(s.days[0])} - ${ucfirst(s.days[s.days.length - 1])}` : s.days.map(d => ucfirst(d)).join(', ');

      // time in format 07:00:00 - 19:00:00 becomes 7am - 7pm
      const timeStr = `${parseInt(s.from.split(':').shift())}am - ${parseInt(s.to.split(':').shift()) - 12}pm PST`;

      return { daysStr, timeStr };
    });
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_WORKING_HOURS_SUCCESS:
      return state
        .set('loaded', true)
        .set('loading', false)
        .set('error', null)
        .set('workingHours', fromJS(prepareSchedule({ days: action.payload.days, holidays: action.payload.holidays })));
    case FETCH_WORKING_HOURS_FAILURE:
      return state.set('loading', false).set('loaded', true).set('error', action.payload);
    case FETCHING_WORKING_HOURS:
      return state.set('loading', true);
    default:
      return state;
  }
};
